var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.stateSync)+" "),_c('router-view'),_c('GlobalToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }